// Client-side helpers to keep the system stable under real staff input.
const configuredMaxUploadBytes = Number(process.env.REACT_APP_MAX_UPLOAD_BYTES || 15 * 1024 * 1024);
export const MAX_UPLOAD_BYTES = Number.isFinite(configuredMaxUploadBytes) && configuredMaxUploadBytes > 0
    ? configuredMaxUploadBytes
    : 15 * 1024 * 1024;
const IMAGE_MIME = /^image\//;

// Validate a file before upload. Returns [ok, message].
export function validateUpload(file) {
    if (!file) return [false, "No file selected"];
    if (file.size > MAX_UPLOAD_BYTES) {
        const mb = (file.size / 1024 / 1024).toFixed(1);
        const maxMb = (MAX_UPLOAD_BYTES / 1024 / 1024).toFixed(0);
        return [false, `File too large (${mb} MB). Max ${maxMb} MB.`];
    }
    return [true, ""];
}

// Compress an image to <= maxBytes using canvas. Returns a File (or original on failure/non-image).
export async function compressImage(file, maxBytes = 1 * 1024 * 1024, maxDim = 1600) {
    if (!IMAGE_MIME.test(file.type)) return file;
    if (file.size <= maxBytes) return file;
    return new Promise((resolve) => {
        const img = new Image();
        const reader = new FileReader();
        reader.onload = e => { img.src = e.target.result; };
        img.onload = () => {
            const scale = Math.min(1, maxDim / Math.max(img.width, img.height));
            const w = Math.round(img.width * scale);
            const h = Math.round(img.height * scale);
            const canvas = document.createElement("canvas");
            canvas.width = w; canvas.height = h;
            canvas.getContext("2d").drawImage(img, 0, 0, w, h);
            canvas.toBlob(
                (blob) => {
                    if (!blob) return resolve(file);
                    resolve(new File([blob], file.name.replace(/\.\w+$/, ".jpg"), { type: "image/jpeg" }));
                },
                "image/jpeg", 0.82,
            );
        };
        img.onerror = () => resolve(file);
        reader.onerror = () => resolve(file);
        reader.readAsDataURL(file);
    });
}
